// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { MatterTypeField } from "../../types";

const matterTypeFieldsModule = {
  async findByMatterTypeId(matterTypeId: string): Promise<MatterTypeField[]> {
    try {
      const result = await sql`
        SELECT * FROM matter_type_fields
        WHERE matter_type_id = ${matterTypeId}
        ORDER BY position ASC, name ASC
      `;
      return (result || []) as MatterTypeField[];
    } catch (error) {
      console.error('Error fetching matter type fields:', error);
      return [];
    }
  },
  
  async findById(id: string): Promise<MatterTypeField | null> {
    try {
      const result = await sql`
        SELECT * FROM matter_type_fields
        WHERE id = ${id}
        LIMIT 1
      `;
      return result[0] as MatterTypeField || null;
    } catch (error) {
      console.error('Error fetching matter type field:', error);
      return null;
    }
  },
  
  async create(data: Omit<MatterTypeField, 'id' | 'created_at' | 'updated_at'>): Promise<MatterTypeField> {
    const result = await sql`
      INSERT INTO matter_type_fields (matter_type_id, name, field_type, description, is_required, position, options, validation)
      VALUES (${data.matter_type_id}, ${data.name}, ${data.field_type}, ${data.description}, 
              ${data.is_required || false}, ${data.position}, ${data.options ? JSON.stringify(data.options) : null}, 
              ${data.validation ? JSON.stringify(data.validation) : null})
      RETURNING *
    `;
    return result[0] as MatterTypeField;
  },
  
  async update(id: string, data: Partial<MatterTypeField>): Promise<MatterTypeField> {
    const result = await sql`
      UPDATE matter_type_fields
      SET name = COALESCE(${data.name}, name),
          field_type = COALESCE(${data.field_type}, field_type),
          description = COALESCE(${data.description}, description),
          is_required = COALESCE(${data.is_required}, is_required),
          position = COALESCE(${data.position}, position),
          options = COALESCE(${data.options ? JSON.stringify(data.options) : undefined}, options),
          validation = COALESCE(${data.validation ? JSON.stringify(data.validation) : undefined}, validation),
          updated_at = now()
      WHERE id = ${id}
      RETURNING *
    `;
    return result[0] as MatterTypeField;
  },
  
  async delete(id: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_type_fields
      WHERE id = ${id}
    `;
    return result.count > 0;
  },
  
  async deleteByMatterTypeId(matterTypeId: string): Promise<boolean> {
    const result = await sql`
      DELETE FROM matter_type_fields
      WHERE matter_type_id = ${matterTypeId}
    `;
    return result.count > 0;
  }
};

export type MatterTypeFieldsModule = typeof matterTypeFieldsModule;

export function registerMatterTypeFields(db: { matterTypeFields?: MatterTypeFieldsModule }) {
  db.matterTypeFields = matterTypeFieldsModule;
}

export { matterTypeFieldsModule as matterTypeFields };
